import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#0b4864] via-[#0d5779] to-[#11729e] text-white">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 py-14 border-b border-white/20">
          {/* ===== Brand / About ===== */}
          <div>
            <h5 className="text-xl font-semibold mb-4 text-white">
              Making Noise Since 2020
            </h5>

            <p className="text-sm text-white/80 max-w-sm mb-5 leading-relaxed">
              As supply chain professionals, we partner with organizations to
              optimize performance and deliver lasting results through
              technology-driven solutions.
            </p>

            {/* Social Icons */}
            <div className="flex space-x-4">
              {/* Facebook */}
              <a
                href="#"
                aria-label="Facebook"
                className="hover:text-[#2DD4BF] transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2v-3h2v-2.3c0-2 1.2-3.1 3-3.1.9 0 1.8.1 1.8.1v2h-1c-1 0-1.3.6-1.3 1.2V12h2.3l-.4 3h-1.9v7A10 10 0 0022 12z" />
                </svg>
              </a>

              {/* Instagram */}
              <a
                href="#"
                aria-label="Instagram"
                className="hover:text-[#2DD4BF] transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M7 2C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5H7zm10 2a3 3 0 013 3v10a3 3 0 01-3 3H7a3 3 0 01-3-3V7a3 3 0 013-3h10zm-5 3a5 5 0 100 10 5 5 0 000-10zm0 2a3 3 0 110 6 3 3 0 010-6zm4.5-.9a1.1 1.1 0 100 2.2 1.1 1.1 0 000-2.2z" />
                </svg>
              </a>

              {/* LinkedIn */}
              <a
                href="#"
                aria-label="LinkedIn"
                className="hover:text-[#2DD4BF] transition"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M4.98 3.5a2.5 2.5 0 11-.02 5 2.5 2.5 0 01.02-5zM3 8.98h4v12H3v-12zM9 8.98h3.8v1.6h.1c.5-.9 1.8-1.9 3.7-1.9 4 0 4.7 2.6 4.7 6v6.3h-4v-5.6c0-1.3 0-3-1.8-3s-2.1 1.4-2.1 2.9v5.7H9v-12z" />
                </svg>
              </a>
            </div>
          </div>

          {/* ===== Quick Links ===== */}
          <div>
            <h5 className="text-lg font-semibold mb-4 text-white">
              Quick Links
            </h5>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <Link to="/" className="hover:text-white">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/career" className="hover:text-white">
                  Career
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* ===== Contact Info ===== */}
          <div>
            <h5 className="text-lg font-semibold mb-4 text-white">
              Contact Info
            </h5>

            <p className="text-sm text-white/80 mb-3">
              📧 <span className="ml-2">info.digitaltranss@gmail.com</span>
            </p>

            <p className="text-sm text-white/80 mb-3">
              📍{" "}
              <span className="ml-2">
                Plot - 138, SahooNibas, Barapur, Basudevpur, Bhadrak, Odisha,
                India, 756046
              </span>
            </p>

            <p className="flex items-center text-sm text-white/80">
              <svg
                className="w-4 h-4 text-white"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.58.57a1 1 0 011 1V20a1 1 0 01-1 1C10.3 21 3 13.7 3 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.46.57 3.59a1 1 0 01-.24 1.01l-2.21 2.19z" />
              </svg>

              <span className="ml-2">+91-83288 66474</span>
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="text-center py-6 text-sm text-white/70">
          © 2025 Digital Transformation Associates. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
